module.exports = __webpack_public_path__ + "static/media/social_youtube_blue.150c05ea.svg";